import React, { useEffect } from "react";
import { ErrorBoundary } from "@action.sustainability/storybook-dashboard/errors";
import { ModalContext } from "./context";
import { useModal } from "./hooks";

const MODALID = "global-modal";

export function ModalHeader({ title, hideClose }) {
  const id = MODALID;
  const _id = `${id}Label`;
  const _title = title ? (
    <h5 className="modal-title" id={_id}>
      {title}
    </h5>
  ) : null;
  return (
    <div className="modal-header">
      {_title}
      {hideClose ? null : (
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      )}
    </div>
  );
}

export function ModalFooter({ footer }) {
  if (!footer) {
    return null;
  }
  return (
    <div className="modal-footer">
      <button type="button" className="btn btn-secondary" data-dismiss="modal">
        Close
      </button>
      {footer}
    </div>
  );
}

export function ModelCloseButton({ className }) {
  return (
    <button type="button" className={className} data-dismiss="modal">
      Close
    </button>
  );
}

export function ModalButton({ text, className }) {
  return (
    <button
      type="button"
      className={className}
      data-toggle="modal"
      data-target={`#${MODALID}`}
    >
      {text}
    </button>
  );
}

export function Modal({ children, title, footer, hideClose }) {
  return (
    <div className="modal-content">
      <ModalHeader title={title} hideClose={hideClose} />
      <div className="modal-body">{children}</div>
      <ModalFooter footer={footer} />
    </div>
  );
}

export default function ModalContainer() {
  const { modalContent, modalFullWidth } = React.useContext(ModalContext);
  const id = MODALID;

  const classNames = modalFullWidth
    ? "modal-dialog modal-dialog-centered pl-4 pr-2"
    : "modal-dialog modal-lg modal-dialog-centered";
  const modalStyle = modalFullWidth ? { maxWidth: "none", width: "100%" } : {};

  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      role="dialog"
      aria-labelledby={`${id}Label`}
      aria-hidden="true"
    >
      <div className={classNames} role="document" style={modalStyle}>
        <ErrorBoundary>{modalContent}</ErrorBoundary>
      </div>
    </div>
  );
}

export function ClearModal() {
  const { hideModal } = useModal();
  useEffect(() => hideModal(), []);
  return null;
}
